import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { CustomTerm, ProfanityFilterEnum, SurveySettings } from '@empathy/survey/base';
import { IMediaForm } from '@empathy/survey-core';

import { ICustomTerm } from './custom-terms.interface';
import { MonitorTerms } from './monitor-terms-form.model';

export interface ISettingsForm {
  logo: FormGroup<IMediaForm>;
  iconLogo: FormGroup<IMediaForm>;
  showLogoInd: FormControl<boolean>;
  useTitleInd: FormControl<boolean>;
  isBackButtonDisabled: FormControl<boolean>;
  useFeedbackInd: FormControl<boolean>;
  monitorTerms: FormGroup<MonitorTerms>;
}

export class SettingsForm {
  form = new FormGroup<ISettingsForm>({
    logo: new FormGroup<IMediaForm>({
      mediaId: new FormControl<string>(''),
      name: new FormControl<string>(''),
      type: new FormControl<string>('')
    }),
    iconLogo: new FormGroup<IMediaForm>({
      mediaId: new FormControl<string>(''),
      name: new FormControl<string>(''),
      type: new FormControl<string>('')
    }),
    showLogoInd: new FormControl<boolean>(true),
    useTitleInd: new FormControl<boolean>(false),
    isBackButtonDisabled: new FormControl<boolean>(false),
    useFeedbackInd: new FormControl<boolean>(false),

    monitorTerms: new FormGroup<MonitorTerms>({
      monitorProblematicInd: new FormControl<boolean>(false),
      flagCurseWordsInd: new FormControl<ProfanityFilterEnum>(ProfanityFilterEnum.Disabled),
      flagGibberishInd: new FormControl<boolean>(false),
      customErrorMessage: new FormControl<string>(''),
      customErrorMessageInd: new FormControl<boolean>(false),
      blockedTerms: new FormArray<FormGroup<ICustomTerm>>([new FormGroup<ICustomTerm>({ type: new FormControl('contains'), term: new FormControl('') })]),
      flaggedTerms: new FormArray<FormGroup<ICustomTerm>>([new FormGroup<ICustomTerm>({ type: new FormControl('contains'), term: new FormControl('') })])
    })
  });

  constructor(condition?: SurveySettings) {
    if (!condition) {
    }
    this.form.patchValue(condition);
  }

  init(settings: SurveySettings): void {
    this.form.patchValue(settings);

    if (this.form.get('monitorTerms') && settings.monitorTerms) {
      this.patchBlockTerms(settings.monitorTerms.blockedTerms);
      this.patchFlagTerms(settings.monitorTerms.flaggedTerms);
    }
  }

  private patchBlockTerms(blockTerms: CustomTerm[]): void {
    if (!blockTerms?.length) {
      return;
    }

    (this.form.get('monitorTerms').get('blockedTerms') as FormArray).clear();
    blockTerms.forEach((term) =>
      (this.form.get('monitorTerms').get('blockedTerms') as FormArray).push(
        new FormGroup({ type: new FormControl(term.type), term: new FormControl(term.term) })
      )
    );
  }

  private patchFlagTerms(flagTerms: CustomTerm[]): void {
    if (!flagTerms?.length) {
      return;
    }

    (this.form.get('monitorTerms').get('flaggedTerms') as FormArray).clear();
    flagTerms.forEach((term) =>
      (this.form.get('monitorTerms').get('flaggedTerms') as FormArray).push(
        new FormGroup({ type: new FormControl(term.type), term: new FormControl(term.term) })
      )
    );
  }
}
